export default __webpack_public_path__ + "static/media/ChevronUpFilled.53009e7a.svg";